import okxWalletIcon from '@ui/assets/okx-wallet.svg';
import { injected } from 'wagmi/connectors';

export const okxConnector = () => {
    const c = injected({
        target: { // Provide the injected target to avoid window.ethereum provider overwrite conflict
            id: 'com.okex.wallet',
            name: 'Binance Wallet Injected',

            // @ts-ignore
            provider: () => window.okxwallet,
        },
        // @ts-ignore
        shimDisconnect: true,
    });

    return (ctx: any) => {
        const connector = c(ctx);

        return {
            ...connector,
            id: 'com.okex.wallet',
            name: 'OKX Wallet',
            icon: okxWalletIcon.src,
            getWalletConnectDeeplink: null,
            getProvider: () => connector.getProvider(),
            getQrCode: () => null,
            // @ts-ignore
            isAuthorized: async () => {
                if (typeof window !== 'undefined' && !(window as any).okxwallet) {
                    return false;
                }

                return connector.isAuthorized();
            },
            get installed() {
                return typeof window !== 'undefined' && !!(window as any).okxwallet;
            },
            get suggested() {
                return false;
            },
            async disconnect() {
                await (window as any).okxwallet.disconnect();
                ctx.emitter.emit('disconnect');
            },
            extension: {
                instructions: {
                    learnMoreUrl: 'https://www.okx.com/web3',
                    steps: [],
                },
            },
            downloadUrls: {
                get download() {
                    if (typeof window === 'undefined')
                        return 'https://www.okx.com/download';
                    const isMobile = /iPhone|iPad|iPod|Android/i.test(
                        window.navigator.userAgent,
                    );
                    if (isMobile) {
                        const dappURL = window.location.href;
                        const deeplink = `okx://wallet/dapp/url?dappUrl=${encodeURIComponent(dappURL)}`
                        const downloadURL = `https://www.okx.com/download?deeplink=${encodeURIComponent(deeplink)}`;
                        
return downloadURL;
                    }
                    
return 'https://www.okx.com/download';
                },
            },
        };
    };
};
